import http from './http';

/*
  客服配置信息
  @see http://mock.qa.91jkys.com/project/70?moduleId=284&interfaseId=2033
*/
export const fetchCustomerConfig = params => {
  const url = 'composite-portal/1.0/customer_config';
  return http({
    url,
    method: 'Get',
    params
  });
};


// 卡尔数据获取
export const fetchPostApiSearchYizhenPageDoctors = params => {
  const url = 'search/2.0/yizhen_page_doctors';
  return http({
    url,
    method: 'post',
    params
  });
};


export const fetchConsultStatus = params => {
  const url = 'consult/3.0/query_consult_status';
  return http({
    url,
    method: 'get',
    params
  });
};

